import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { PaymentResult } from '@/types/dtos/transactions/response/payment-result.dto';
import { GET_ORGANIZATION_QUERY_KEY } from '@/state/queries/organizations/use-get-organization.ts';
import { SUBSCRIPTION_CHECKOUT_CART_QUERY_KEY } from '@/state/queries/transactions/use-subscription-checkout-cart';
import { invalidateAllQuotaBalances } from '@/state/queries/entitlements/use-quota-balances';

export function useCheckoutSubscriptionCart() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: { organizationId: string; redirectUrlAfterPayment: string }) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/transactions/organization/${payload.organizationId}/subscription-checkout-cart/checkout`;
      return sendJSONRequest({
        url,
        method: METHOD.POST,
        body: { redirectUrlAfterPayment: payload.redirectUrlAfterPayment },
        token: token ?? '',
      }) as Promise<PaymentResult>;
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({ queryKey: [GET_ORGANIZATION_QUERY_KEY, variables.organizationId] });
      await queryClient.invalidateQueries({
        queryKey: [SUBSCRIPTION_CHECKOUT_CART_QUERY_KEY, variables.organizationId],
      });
      await invalidateAllQuotaBalances(queryClient);
    },
  });
}
